import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
import { useFirebaseApp } from 'reactfire'

const Footer=()=>{
  const [state, setstate] = useState({categories:[]})
  const firebase=useFirebaseApp()
  // firebase.analytics()
  const firestore=firebase.firestore()
  useEffect(()=>{
    firestore.collection('categories').get().then(querySnapshot=>{
      const categories=[]
      querySnapshot.forEach((doc)=>{
        categories.push({id:doc.id,name:doc.data().name})
      })
      setstate({
        categories
      })
    })
  },[firestore])

  return (
    <footer className="footer">
      <div className="social-media-container">
        <p>Siguenos en nuestras redes sociales</p>
        <ul className="social-media-list">
          <li className="social-media-item">
            <a target='_blank' rel='noreferrer' href='https://www.facebook.com/tuestilo.p'>
            <div className="social-media-item-image">
              <img src="/icons/facebook.svg" alt="facebook"/>
            </div>
            <p>@tuestilo.pe</p>
            </a>
          </li>
          <li className="social-media-item">
          <a target='_blank' rel='noreferrer' href='https://www.instagram.com/yourstyle_per/'>
            <div className="social-media-item-image">
              <img src="/icons/instagram.svg" alt="instagram"/>
            </div>
            <p>@yourstyle_per</p>
            </a>
          </li>
        </ul>
      </div>
      <div className="categories-container">
        <p>Categorias</p>
        <ul className="categories-list">
          {
            state.categories &&
            state.categories.map(c=>(
              <li key={c.id} className="categories-item">
                <NavLink to={`/categorias/${c.id}`}>{c.name}</NavLink>
              </li>
            ))
          }
        </ul>
      </div>
      <div className="rights-container">
        <div className="rights-image">
        <div className="rights-image-container">
          <img src="/logo2.svg" alt="logo-yourstyles"/>
        </div>
        </div>
        <div className="rights-text-container">
          <p>2020 &copy; Your Style</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
